export const PRODUCTS = [
  {
    id: "glasshouse-gloss",
    name: "Glasshouse Gloss",
    kind: "High-shine lip gloss",
    price: 14.99,
    image: "/images/gloss.jpg",
    tagline: "Mirror shine. Zero cling.",
    description:
      "A cushiony, glass-finish gloss that catches the light without the sticky feel. Built around flattering nude, brown and pink tones you can wear every day.",
    shades: [
      { name: "Mocha Glaze", hex: "#5A3827", note: "Warm brown with a soft pearl" },
      { name: "Bare Honey", hex: "#C99A7E", note: "Universal warm nude" },
      { name: "Petal Silk", hex: "#E3A3A9", note: "Sheer rose pink" },
      { name: "Berry Velvet", hex: "#7E3446", note: "Deep berry tint" },
    ],
    details: {
      ritual: "Swipe from the centre of the lips outward. Layer over liner for a defined glossy lip.",
      formula: "[Ingredient list pending final manufacturer formula]",
      shipping: "Ships within the United States. [Shipping times and returns policy to be confirmed]",
    },
  },
  {
    id: "melt-lip-oil",
    name: "Melt Lip Oil",
    kind: "Hydrating lip oil",
    price: 17.99,
    image: "/images/oil.jpg",
    tagline: "A slow-melting drop of care.",
    description:
      "A nourishing tinted oil that melts onto lips for a dewy, cared-for finish. Wear it alone, over gloss, or as an overnight treatment.",
    shades: [
      { name: "Honey Dew", hex: "#DFB087", note: "Golden warmth, high dew" },
      { name: "Rosewood", hex: "#B86F6B", note: "Rosy mocha tint" },
      { name: "Crystal Halo", hex: "#F1E4DC", note: "Clear, mirror-like glaze" },
    ],
    details: {
      ritual: "Apply a generous layer with the doe-foot applicator. Reapply whenever lips feel dry.",
      formula: "[Ingredient list pending final manufacturer formula]",
      shipping: "Ships within the United States. [Shipping times and returns policy to be confirmed]",
    },
  },
  {
    id: "golden-hour-trio",
    name: "Golden Hour Trio",
    kind: "Lip gift set",
    price: 34.99,
    compareAt: 47.97,
    image: "/images/trio.jpg",
    tagline: "The whole ritual, boxed in blush.",
    description:
      "Gloss, lip oil and lip liner in our signature pink, cream and mocha keepsake box. Made for birthdays, holidays, graduations — or yourself.",
    shades: [
      { name: "Everyday Nudes", hex: "#A87664", note: "Mocha Glaze + Honey Dew + nude liner" },
      { name: "Rose Romance", hex: "#D88B94", note: "Petal Silk + Rosewood + rose liner" },
    ],
    details: {
      ritual: "Line, melt, then glaze. Three steps to your signature lip.",
      formula: "[Ingredient lists pending final manufacturer formulas]",
      shipping: "Ships within the United States in our gift box. [Shipping times and returns policy to be confirmed]",
    },
  },
];

export const getProduct = (id) => PRODUCTS.find((p) => p.id === id);

export const BUNDLE = { gloss: "glasshouse-gloss", oil: "melt-lip-oil", off: 8.99 };

export function bundleInfo(lines = []) {
  const qty = (id) => lines.filter((l) => l.productId === id).reduce((s, l) => s + l.qty, 0);
  const gloss = qty(BUNDLE.gloss);
  const oil = qty(BUNDLE.oil);
  const count = Math.min(Math.floor(gloss / 2), oil);
  let hint = null;
  if (gloss < 2) hint = `Add ${2 - gloss} more Glasshouse Gloss to unlock 50% off a Melt Lip Oil`;
  else if (oil < Math.floor(gloss / 2)) hint = "Add a Melt Lip Oil — it's 50% off with your glosses";
  return { count, discount: Math.round(count * BUNDLE.off * 100) / 100, hint };
}

export const money = (n) => `$${Number(n ?? 0).toFixed(2)}`;
